import {gql, useLazyQuery} from '@apollo/client';
import {Box, Typography, Button} from '@mui/material';

import React from 'react';
import moment from 'moment';
import {Image} from '@mui/icons-material';
import {ReportPackFragment} from '../../schema-types/ReportPackFragment';
import {
  GetReportPackDocumentURL,
  GetReportPackDocumentURLVariables,
} from '../../schema-types/GetReportPackDocumentURL';

export const ExistingFile: React.FC<{reportPack: ReportPackFragment}> = ({
  reportPack,
}) => {
  const [onFetchDocumentUrl] = useLazyQuery<
    GetReportPackDocumentURL,
    GetReportPackDocumentURLVariables
  >(gql`
    query GetReportPackDocumentURL($reportPackId: UUID!) {
      getReportPackDocumentUrl(reportPackId: $reportPackId)
    }
  `);

  if (!reportPack.documentUploadDate) {
    return null;
  }

  return (
    <Button
      variant="text"
      onClick={() => {
        onFetchDocumentUrl({
          variables: {
            reportPackId: reportPack.id,
          },
          fetchPolicy: 'no-cache',
          nextFetchPolicy: 'no-cache',
        }).then(({data, error}) => {
          if (data?.getReportPackDocumentUrl) {
            window.open(data?.getReportPackDocumentUrl, '_blank');
          }
        });
      }}
      sx={{alignItems: 'center', display: 'flex', width: '50%'}}
    >
      <Image
        sx={{
          border: '1px solid #FFD700',
          borderRadius: '4px',
          height: 40,
          marginRight: 2,
          padding: '4px',
          width: 40,
        }}
      />
      <Box
        sx={{
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          display: 'flex',
        }}
      >
        <Typography>
          <strong>{reportPack.documentFilename}</strong>
        </Typography>
        Uploaded: {moment(reportPack.documentUploadDate).format('DD/MM/YYYY')}
      </Box>
    </Button>
  );
};
